<script setup lang="ts">
// ログを取りつつ外部サイトにリダイレクトするページ
import { isEqual } from 'ohash';

const redirectableHosts = [
  'okane-kenko.jp',
  'www.sonylife.co.jp',
  'special.renosy.com',
  /* 202311楽天証券用リンク追加ここから */
  // refs: https://www.notion.so/400f/redirect_external-97fc84f0183f4d119a03612711d12484?pvs=4
  'www.rakuten-sec.co.jp',
  'lifeplan.rakuten-sec.co.jp',
  'hoken.rakuten.co.jp',
  'member.rakuten-sec.co.jp',
  'account.rakuten-sec.co.jp',
  /* 202311楽天証券用リンク追加ここまで */
  // 202312LIFULL用リンク
  // refs: https://docs.google.com/presentation/d/1SwvR4cBvGdzQhtcETeoy9MzEAVsPMv0-9vGIajNkQbo/edit#slide=id.g25d40041d8e_0_183
  'counter.homes.co.jp',
  'public-docs.400f.jp',
];

definePageMeta({
  layout: 'plain',
  middleware: async (to, from, next) => {
    if (import.meta.server) {
      return;
    }
    const route = useRoute();
    const url = getStringQuery(route.query.url);
    if (!url) {
      return next('/');
    }

    const {
      public: { appOrigin },
    } = useRuntimeConfig();
    const logger = useRawLogger();
    const metaArgs = useLoggerMetaArgs();

    const isRouterNavigation = !isEqual(to, from);
    const referer = isRouterNavigation
      ? new URL(from.fullPath, appOrigin).toString()
      : document.referrer;

    logger.event.viewExternalPage(
      {
        ...metaArgs.value,
        referer,
      },
      {
        to: { url },
      }
    );
  },
});

const router = useRouter();
const route = useRoute();
const url = getStringQuery(route.query.url);
const showFallback = ref(false);

(async () => {
  if (import.meta.server) {
    return;
  }
  // 失敗したら画面のリンク表示にフォールバックする
  wait(3000).then(() => {
    showFallback.value = true;
  });

  // middlewareでチェックしているが、型のためにもう一度チェック
  if (!url) {
    router.replace('/');
    return;
  }

  // オープンリダイレクト脆弱性対策
  const host = new URL(url).host;
  if (!redirectableHosts.includes(host)) {
    router.replace('/');
    return;
  }

  window.location.replace(url);
})();
</script>

<template>
  <div v-if="url && showFallback">
    自動的に遷移しない場合はこちらをクリックしてください.
    <a :href="url">{{ url }}</a>
  </div>
</template>
